export const radii = [0, 4, 6, 8, 12, 16];
